import * as httpConfig from './api.config.json';
/**
 * This file has all the rest urls for http request
 * @author - Ashok
 */
/**
 * local host settings
 */
// const scheme = "http";
// const host = "localhost";
//const host='api.exathought.com';
//const host='192.168.0.69'
// const port = "4000";
//const port ='80';
// local = {"scheme":"http","host":"localhost","port":"4000"}
//prod = {"scheme":"https","host":"prodapi.schoolpicot.com","port":""}
//const baseUrl = `${scheme}://${host}:${port}`;
/**
 * Owner API's
 */
const baseUrl = `${httpConfig.scheme}://${httpConfig.host}${(httpConfig.port !== '') ? ':' + httpConfig.port : ''}`

export const SignUpURL = () => {
  return `${baseUrl}/owners`;
};
export const createSchoolURL = (ownerId) => {
  return `${baseUrl}/owners/${ownerId}/schools`;
}

export const getUserProfileByCognitoId = (userCognitoId) => {
  return `${baseUrl}/users/${userCognitoId}`;
}

export const getAdminByOwnerIdAndSchoolId = (ownerId, schoolId) => {
  return `${createSchoolURL(ownerId)}/${schoolId}/admins`
}



export const addGradeBySchoolId = (schoolId) => {
  return `${baseUrl}/schools/${schoolId}/grades`
}
export const getSchoolInformationByAdminId = (ownerId, adminId) => {
  return `${baseUrl}/owners/${ownerId}/admins/${adminId}/schools`
}

export const getGradeMasterData = () => {
  return `${baseUrl}/gradeMasterData`
}

export const getSubjectMasterData = () => {
  return `${baseUrl}/subjectMasterData`
}
export const getUpdateSchoolURL = (ownerId, schoolId) => {
  return `${baseUrl}/owners/${ownerId}/schools/${schoolId}`
}
export const getupdateSchoolScheduleConstraintsURL = (ownerId, schoolId) => {
  return `${baseUrl}/owners/${ownerId}/schools/${schoolId}/updateSchoolScheduleConstraints`
}
export const getupdateSchoolMasterURL = (ownerId, schoolId) => {
  return `${baseUrl}/owners/${ownerId}/schools/${schoolId}/updateSchoolMaster`
}

export const getGrades = (ownerId, schoolId) => {
  return `${baseUrl}/owners/${ownerId}/schools/${schoolId}/grades`
}
export const getSubjects = (ownerId, schoolId) => {
  return `${baseUrl}/owners/${ownerId}/schools/${schoolId}/grades`
}

export const getcontextualHelpURL = () => {
  return `${baseUrl}/contextualHelp`
}
export const geti18nMessagesURL = () => {
  return `${baseUrl}/i18nMessages`
}

export const getSubscriptionPlansURL = () => {
  return `${baseUrl}/subscriptionPlans`
}

export const getSchoolsSummaryURL = (ownerId) => {
  return `${baseUrl}/owners/${ownerId}/schools?summary=true`;
}

export const getAddMoreSectionsToSubscriptionsURL = () => {
  return `${baseUrl}/addMoreSectionsToSubscription`
}

export const getAddMoreTimetablesToSubscriptionsURL = () => {
  return `${baseUrl}/addMoreTimetablesToSubscription`
}

export const getCancelSubscriptionURL = () => {
  return `${baseUrl}/cancelSubscription`
}

export const updateActiveSchoolURL = (ownerId) => {
  return `${baseUrl}/owners/${ownerId}/activeSchools`
}

export const getSchoolInformationByIdURL = (schoolId) => {
  return `${baseUrl}/schools/${schoolId}`
}

export const getExistingAdmins = (schoolId) => {
  return `${baseUrl}/schools/${schoolId}/existingAdmins`
}

export const sendEmail = (emailId, transferOwnerId, schoolId) => {
  let urlArray = window.location.href.split("#");
  let url = urlArray[0] + "#/ownerInvite";
  return `${baseUrl}/schools/${schoolId}/sendEmail/${emailId}/${transferOwnerId}?redirect_url=${url}`
}

export const sendEmailForReject = (emailId, transferOwnerId, schoolId) => {
  let urlArray = window.location.href.split("#");
  let url = urlArray[0] + "#/ownerInvite";
  return `${baseUrl}/schools/${schoolId}/sendEmailForReject/${emailId}/${transferOwnerId}?redirect_url=${url}`
}

export const sendEmailForgotPassword = (emailId) => {
  return `${baseUrl}/sendEmailForgotPassword/${emailId}`
}

export const checkIsAlreadyOwner = (transferOwnerId) => {
  return `${baseUrl}/makeOwner/checkIsAlreadyOwner/${transferOwnerId}`
}

export const acceptOwnerInviteUrl = (transferOwnerId) => {
  return `${baseUrl}/makeOwner/${transferOwnerId}`
}

export const verifyTimeTableBySchoolIdUrl = (ownerId,schoolId) => {
  //return `${getSchoolInformationByIdURL(schoolId)}/verifymodel`
  return `${baseUrl}/owners/${ownerId}/schools/${schoolId}/verifymodel`
}
export const generateTimeTableBySchoolIdUrl = (ownerId,schoolId) => {
  return `${baseUrl}/owners/${ownerId}/schools/${schoolId}/generateTimetable`
}
export const getTimeTableByIdAndTypeId = (timeTableId, typeId) => {
  return `${baseUrl}/${timeTableId}/${typeId}`
}

export const getSystemConfigURL = () => {
  return `${baseUrl}/globalConfig`
}

export const getOrderHistoryBySchoolIdURL = (schoolId) => {
  return `${getSchoolInformationByIdURL(schoolId)}/orderHistory`
}

export const  getDeleteSchoolURL= (ownerId, schoolId) => {
  return `${baseUrl}/owners/${ownerId}/schools/${schoolId}`
}